function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M462.806,68.109H27.193C12.199,68.109,0,80.307,0,95.301v299.396c0,14.994,12.199,27.193,27.193,27.193h435.613 c14.995,0,27.194-12.199,27.194-27.193V95.301C490,80.307,477.801,68.109,462.806,68.109z M27.193,88.109h435.613 c3.967,0,7.194,3.227,7.194,7.192V126.1H20V95.301C20,91.335,23.226,88.109,27.193,88.109z M462.806,401.891H27.193 c-3.966,0-7.193-3.227-7.193-7.193V146.1h450v248.598C470,398.665,466.772,401.891,462.806,401.891z"
}), React.createElement("path", {
  d: "M188.111,210.43c-3.905-3.905-10.237-3.904-14.142,0.001l-45.152,45.152c-1.875,1.875-2.929,4.419-2.929,7.071 c0,2.652,1.054,5.195,2.929,7.071l45.152,45.151c1.953,1.953,4.512,2.929,7.071,2.929s5.119-0.977,7.071-2.929 c3.905-3.905,3.905-10.237-0.001-14.143l-38.081-38.08l38.082-38.082C192.017,220.668,192.017,214.335,188.111,210.43z"
}), React.createElement("path", {
  d: "M308.912,210.431c-3.905-3.905-10.235-3.905-14.143-0.001c-3.905,3.905-3.905,10.237,0,14.143l38.081,38.082l-38.081,38.08 c-3.905,3.905-3.905,10.237,0,14.143c1.953,1.953,4.512,2.929,7.071,2.929c2.559,0,5.118-0.977,7.071-2.929l45.152-45.151 c1.875-1.876,2.929-4.419,2.929-7.071c0-2.652-1.054-5.196-2.929-7.071L308.912,210.431z"
}), React.createElement("path", {
  d: "M269.591,208.576c-4.931-2.491-10.945-0.513-13.436,4.417l-47.283,93.591c-2.49,4.929-0.513,10.944,4.417,13.435 c1.446,0.73,2.985,1.076,4.501,1.076c3.653,0,7.173-2.009,8.934-5.492l47.283-93.591 C276.497,217.082,274.52,211.067,269.591,208.576z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var SvgIcon2 = function SvgIcon2(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 490 490",
    style: {
      enableBackground: "new 0 0 490 490"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcon2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon2.4fbe41c0.svg";
export { ForwardRef as ReactComponent };